let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3ODxI")).then(() => parcelRequire('7ZIUJ'));